module.exports = __webpack_public_path__ + "app-static/img/icon-shtg.85a01f22.png";